module.exports = __webpack_public_path__ + "static/media/slide2.72988f18.webp";